import React from 'react';

interface MyButtonProps {
    disabled?: boolean;
    onClick?: () => void;
    title: string;
    isSecundary?: boolean;
    backgrounColor?: string;
}

const MyButton: React.FC <MyButtonProps> = ({ disabled, onClick, title, isSecundary, backgrounColor }) => {
    return (
        isSecundary ? (
            <button disabled={disabled} onClick={onClick} className='myBorder p-2 rounded-2' style={{ backgroundColor: backgrounColor? backgrounColor : "#024442",  borderColor: backgrounColor ? backgrounColor : "#024442" }}>
                <span className='h4' style={{ color: "#ffffff" }}>{title}</span>
            </button>
        ):(
            <button disabled={disabled} onClick={onClick} className='myBorder p-2 rounded-2' style={{ backgroundColor:backgrounColor? backgrounColor :  "#024442",  borderColor: backgrounColor ? backgrounColor : "#024442" }}>
                <span className='h4' style={{ color: "#ffc000" }}>{title}</span>
            </button>
        )
    )
}

export default MyButton